import { BackendModel, BackendService } from "../core/backend.service";

export class ParametricWithIcon extends BackendModel {

  static path = '/parametricas/';
  id: number;
  description: string;
  icono: string;

  constructor(protected backendService: BackendService, model?: ParametricWithIcon) {
    super(backendService, model);
  }

}



// WEBPACK FOOTER //
// ./src/app/cliente/parametricWithIcon.model.ts